import React from "react";
import "../css/HomePage.css";

const Item = ({ icon, title }) => (
  <article className="mtg-why-item" role="listitem">
    <img src={icon} alt="" loading="lazy" decoding="async" />
    <h3>{title}</h3>
  </article>
);

export default function WhyUseSection() {
  return (
    <section className="mtg-why" aria-labelledby="why-title">
      <div className="mtg-why-inner">
        <h2 id="why-title">Why use Mentor To Go?</h2>

        <div className="mtg-why-grid" role="list">
          <Item
            icon="https://mentortogether.org/wp-content/uploads/2024/12/free-to-use-icon.svg"
            title="It’s free to use"
          />

          <Item
            icon="https://mentortogether.org/wp-content/uploads/2024/12/one-to-one-guidence-icon.svg"
            title="1:1 guidance"
          />

          <Item
            icon="https://mentortogether.org/wp-content/uploads/2024/12/expand-skillset.svg"
            title="Expand your skillset"
          />

          <Item
            icon="https://mentortogether.org/wp-content/uploads/2024/12/build-connections.svg"
            title="Build connections"
          />

          <Item
            icon="https://mentortogether.org/wp-content/uploads/2024/12/flexible-scheduling.svg"
            title="Flexible session scheduling"
          />

          <Item
            icon="https://mentortogether.org/wp-content/uploads/2024/12/work-on-platform.svg"
            title="Your one-stop shop for mentoring"
          />
        </div>
      </div>
    </section>
  );
}
